import { useCallback, useRef } from 'react';

import { useHandleRef } from 'components/presenters/Card/hooks/useHandleRef/useHandleRef';

interface RentalsCard {
  ref: React.RefObject<HTMLDivElement | null>;
  handleRef: (value: HTMLDivElement | null) => void;
}

export function useRentalsCardRef(itemWidth: number, imageHeight: number): RentalsCard {
  const ref = useRef<HTMLDivElement | null>(null);
  const setRef = useCallback((value: HTMLDivElement | null) => {
    ref.current = value;
  }, []);
  const handleRef = useHandleRef({ setRef, itemWidth, imageHeight });

  return { ref, handleRef };
}
